import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './components/auth/Login';
import Layout from './components/layout/Layout';
import ToolCatalog from './components/catalog/ToolCatalog';
import ToolManagement from './components/admin/ToolManagement';
import UserManagement from './components/admin/UserManagement';
import RoleManagement from './components/admin/RoleManagement';
import { Spinner } from './components/common/ui';

const PrivateRoute = ({ element, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;

  // Roles are user-created, so only the admin screens carry an allowlist.
  if (requiredRole && !requiredRole.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};

const AppRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />

        {/* The catalog is open to any signed-in role — the backend decides
            which tools come back. */}
        <Route path="dashboard" element={<PrivateRoute element={<ToolCatalog />} />} />

        <Route
          path="admin/tools"
          element={<PrivateRoute element={<ToolManagement />} requiredRole={['admin']} />}
        />
        <Route
          path="admin/users"
          element={<PrivateRoute element={<UserManagement />} requiredRole={['admin']} />}
        />
        <Route
          path="admin/roles"
          element={<PrivateRoute element={<RoleManagement />} requiredRole={['admin']} />}
        />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
